<script>
export default {
  name: 'BreadcrumbsPreview',

  props: {
    labels: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<template>
  <div class="article-breadcrumbs-preview">
    <template v-for="(label, index) in labels">
      <span
        v-if="index > 0"
        :key="`sep-${index}`"
        class="article-breadcrumbs-separator"
      >›</span>
      <span :key="`label-${index}`">{{ label }}</span>
    </template>
  </div>
</template>
